import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RuntimeError } from '@blaze-runtime/engine-domain';

import { EngineState } from '../engine';

import { selectRuntimeErrors } from './runtime-errors.selectors';

@Injectable({ providedIn: 'root' })
export class RuntimeErrorsFacade {
  private readonly store = inject(Store<EngineState>);

  selectRuntimeErrors(): Observable<Record<string, RuntimeError>> {
    return this.store.select(selectRuntimeErrors);
  }
}
